import React, {Component} from 'react'
import ReactSelect from 'react-select'

class SwitchLanguage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            value: null,
            options: [],
            currentOption: null,
        }
        this.switchLanguage = this.switchLanguage.bind(this)
    }

    componentDidMount() {
        let value
        if (this.props.value) {
            value = this.props.value
        }

        let options = this.props.options
        let links = document.querySelectorAll('link');

        for(let i in options){
            for(let link in links){
                if(links[link].rel == 'alternate' && links[link].hreflang == options[i].class.replace('locale_','')){
                    options[i].value = links[link].href;
                    break;
                }
            }
        }

        if (options[0].class === 'locale_') {
            let firstItem = options.shift()
        }

        this.setState({options, value}, () => this.getCurrentLanguage(this.state.value))
    }

    switchLanguage(selected) {
        window.location.replace(selected.value)
    }

    getCurrentLanguage(iso) {
        if (!iso) return
        // console.log(this.state);
        const {options} = this.state
        const current = options.filter(o => o.selected === true)
        if (!current) return
        const currentOption = current[0]
        const value = currentOption.label
        this.setState({value, currentOption})
    }

    render() {
        return <ReactSelect
        ref="select"
        name="switch-language"
        value={this.state.currentOption}
        options={this.state.options}
        placeholder={this.state.value}
        onChange={this.switchLanguage}
        searchable={false}
        clearable={false}
        />
    }
}

export default (SwitchLanguage)



// WEBPACK FOOTER //
// ./vendor/bbs/crt/src/resources/views/components/footer/js/SwitchLanguage.js